import React from 'react'

function Insert (props) {
    return (
        <span>{props.children}</span>
    );
};

export default Insert;
